class Notification {

    show(message, error = false) {
        this.close();

        const root = document.getElementById('root');

        const divContainer = document.createElement('div');
        divContainer.className = 'clearfix notification-container';
        if (error) {
            divContainer.className += ' error';
        } else {
            divContainer.className += ' success';
        }

        const divLeft = document.createElement('div');
        divLeft.className = 'notification-text';
        divLeft.innerText = message;

        const spanCloseButton = document.createElement('span');
        spanCloseButton.className = 'notification-close-button';
        spanCloseButton.onclick = () => this.close();
        spanCloseButton.innerHTML = '&times;';

        divContainer.appendChild(divLeft);
        divContainer.appendChild(spanCloseButton);

        root.appendChild(divContainer);
        this.divContainer = divContainer;

        setTimeout(() => {
            divContainer.className = divContainer.className + ' show';
            setTimeout(() => {
                this.close();
            }, 5000);
        }, 10);
    }

    close() {
        if (this.divContainer) {
            this.divContainer.className = this.divContainer.className.replace(/\b show\b/g, '');
            setTimeout(() => {
                if (this.divContainer) {
                    this.divContainer.remove();
                }
                this.divContainer = null;
            }, 500);
        }
    }
}

const notification = new Notification();
export default notification;